module.exports = __webpack_public_path__ + "static/media/portfolio.fcabf411.png";